const Settings = require('@transfeeradev/settings');
const { applications } = require('@transfeeradev/api-enums');

let APP_IDS_CACHE = null;

class ApplicationIdService {
  static async get(applicationType) {
    if (!APP_IDS_CACHE) {
      await ApplicationIdService.fillCache();
    }

    switch (applicationType) {
      case applications.ADMIN:
      case applications.APP:
      case applications.CONTACERTA:
        return APP_IDS_CACHE[applicationType];
      default:
        throw new Error('Application is required');
    }
  }

  static async fillCache() {
    const tokens = await Settings.get(Settings.TOKENS);
    APP_IDS_CACHE = {
      [applications.ADMIN]: tokens.auth.admin.clientId,
      [applications.APP]: tokens.auth.app.clientId,
      [applications.CONTACERTA]: tokens.auth.contacerta.clientId
    };
  }

  static clearCache() {
    APP_IDS_CACHE = null;
  }
}

module.exports = ApplicationIdService;
